// extracted by mini-css-extract-plugin
module.exports = {"base":"base_267wyL","isLoading":"isLoading_2_EvoT base_267wyL"};